import { TransactionEvent } from '../../../types/reducerTypes'
import { amountFromWei } from '../../../utils/amount'

export function getTransactionEthAmount(transaction: TransactionEvent) {
  const { event } = transaction
  return event === 'Purchase'
    ? amountFromWei(transaction.meta.amountIn, 18).toString()
    : amountFromWei(transaction.meta.amountOut, 18).toString()
}

export function getTransactionTokenAmount(
  transaction: TransactionEvent,
  decimals: number,
) {
  const { event } = transaction
  return event === 'Purchase'
    ? amountFromWei(transaction.meta.amountOut, decimals).toFixed(0)
    : amountFromWei(transaction.meta.amountIn, decimals).toFixed(0)
}

/**
 * format the number by trimming unnecessary digits without fixed decimal places.
 *
 * @example
 * // returns 0.0000035
 * formatNumberToFirstDecimalDigit(0.0000035450233)
 * // returns 0.0020
 * formatNumberToFirstDecimalDigit(0.0020450233)
 * */
export function formatNumberToFirstDecimalDigit(
  value: number | string | bigint,
  {
    precision = 2,
    decimals = 18,
  }: {
    precision?: number
    decimals?: number
  } = {},
): string {
  const sanitizedValue = typeof value === 'string' ? value.replace(/,/g, '') : value;

  const num = Number(sanitizedValue)
  // Convert number to string to handle very small numbers
  let numStr = num.toFixed(decimals)

  // Find the index of the first significant digit after "0."
  const significantIndex = numStr.indexOf('0.') + 2

  // Find the index of the first non-zero digit after "0."
  let firstNonZeroIndex = significantIndex
  while (numStr[firstNonZeroIndex] === '0') {
    firstNonZeroIndex++
  }

  // Calculate the precision needed
  const digits = firstNonZeroIndex - significantIndex + precision

  // Format the number with the calculated precision
  return num === 0 ? '0' : num.toFixed(digits)
}

export function formatNumberWithDecimalSubscript(value: string) {
  const valueStr = value.toString()
  const [intPart, decPart] = valueStr.split('.')

  if (!decPart) {
    // If there is no decimal part, return the value as is
    return valueStr
  }

  // Find the position of the first non-zero digit in the decimal part
  const firstNonZeroIndex = decPart.split('').findIndex((char) => char !== '0')

  if (firstNonZeroIndex === -1) {
    // Handle the case where there are no non-zero digits (value is effectively zero)
    return '0'
  } else if (firstNonZeroIndex < 3) {
    // Less than 3 leading zeros, return the value as is
    return valueStr
  }
  // There are 3 or more leading zeros, format the string with subscript
  const leadingZeros = firstNonZeroIndex
  const significantDigits = decPart.slice(firstNonZeroIndex)
  return `${intPart}.0<sub>${leadingZeros - 1}</sub>${significantDigits}`
}

export const zviIcons = {
  0: '/memecoin-launcher/zvi/plankton.svg',
  1: '/memecoin-launcher/zvi/prawn.svg',
  2: '/memecoin-launcher/zvi/fish.svg',
  3: '/memecoin-launcher/zvi/whale.svg',
}

export const getZviIconIndex = (score: number) => {
  if (score < 25) return 0
  if (score < 50) return 1
  if (score < 75) return 2
  return 3
}
